import { Link } from "react-router-dom";
import { Film, Lock, Mail, Globe, Phone, MapPin } from "lucide-react";
import { PaymentBadges } from "@/components/PaymentBadges";

const LEGAL_LINKS = [
  { to: "/hakkimizda", label: "Hakkımızda", testid: "footer-about-link" },
  { to: "/gizlilik", label: "Gizlilik Sözleşmesi", testid: "footer-privacy-link" },
  { to: "/mesafeli-satis", label: "Mesafeli Satış Sözleşmesi", testid: "footer-distance-link" },
  { to: "/teslimat-iade", label: "Teslimat ve İade Şartları", testid: "footer-delivery-link" },
];

export function Footer() {
  return (
    <footer className="border-t border-white/10 bg-black mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <Film className="w-5 h-5 text-gold" />
            <span className="font-serif text-lg">İnce Fikirler</span>
            <span className="text-[10px] uppercase tracking-[0.25em] text-gold/80 mt-1">AI Studio</span>
          </div>
          <p className="text-white/50 text-sm leading-relaxed max-w-xs">
            Yapay zeka destekli prodüksiyon stüdyosu. Fikirden perdeye tüm süreci tek platformda yönetin.
          </p>
          <p className="text-xs uppercase tracking-widest text-white/40 mt-6 mb-3">Güvenli Ödeme</p>
          <PaymentBadges />
        </div>

        <div>
          <p className="text-xs uppercase tracking-widest text-white/40 mb-4">Kurumsal & Yasal</p>
          <ul className="space-y-2.5 text-sm">
            {LEGAL_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} data-testid={l.testid} className="text-white/70 hover:text-gold transition-colors">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-xs uppercase tracking-widest text-white/40 mb-4">İletişim</p>
          <ul className="space-y-2.5 text-sm text-white/70">
            <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-gold" /> info@incefikirler.tv</li>
            <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-gold" /> +90 532 176 74 41</li>
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 text-gold mt-0.5" /> Ahmediye Mah. Dönmedolap Sk. No:56/A Üsküdar / İstanbul</li>
            <li className="flex items-center gap-2"><Globe className="w-4 h-4 text-gold" /> incefikirler.tv</li>
          </ul>
          <div className="flex items-center gap-2 mt-5 text-emerald-400 text-xs">
            <Lock className="w-4 h-4" /> 256-bit SSL ile güvenli ödeme
          </div>
        </div>
      </div>
      <div className="border-t border-white/5 py-5 text-center text-white/30 text-xs px-6">
        © 2026 İnce Fikirler AI Studio. Tüm hakları saklıdır. Ödeme altyapısı iyzico tarafından sağlanmaktadır.
      </div>
    </footer>
  );
}
